var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-42dc9032"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-ellipsis-v" }, null, -1 /* HOISTED */));
const _hoisted_2 = [
    _hoisted_1
];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1 /* HOISTED */));
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa-kit fa-code-pull-request-regular" }, null, -1 /* HOISTED */));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa-kit fa-variable-instance-linked" }, null, -1 /* HOISTED */));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa-kit fa-variable-instance-unlinked" }, null, -1 /* HOISTED */));
const _hoisted_9 = ["href"];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-external-link" }, null, -1 /* HOISTED */));
const _hoisted_11 = ["onClick"];
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-edit" }, null, -1 /* HOISTED */));
const _hoisted_13 = ["onClick"];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa-regular fa-list-tree" }, null, -1 /* HOISTED */));
const _hoisted_15 = ["onClick"];
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-brackets-curly" }, null, -1 /* HOISTED */));
const _hoisted_17 = ["onClick"];
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-brackets-curly" }, null, -1 /* HOISTED */));
import { ElDivider, ElDropdown, ElDropdownItem, ElDropdownMenu, } from "element-plus";
import { useCampaignEditorPath } from "src/campaign/edit/component-id-url-mapper";
import { useComponentDisplayName } from "src/shared/store/component-built/composables";
import DrawerTrigger from "src/shared/v-components/ui/drawer/DrawerTrigger.vue";
import { computed, ref, toRef } from "vue";
import Session from "Session";
import EditComponentSettingDrawer from "../../edit-drawer/EditComponentSettingDrawer.vue";
import CampaignComponentVariableImpactDrawer from "src/shared/v-components/campaign-component-variable/input/inheritance/CampaignComponentVariableImpactDrawer.vue";
import ConfirmPushValueToParentDialog from "src/shared/v-components/campaign-component-variable/input/inheritance/ConfirmPushValueToParentDialog.vue";
import JsonDrawer from "src/shared/v-components/ui/drawer/JsonDrawer.vue";
import { useComponentVariable } from "src/shared/store/component/composables/useComponentVariable";
import { saveComponentVariable } from "src/shared/store/component/service/saveComponent";
import { useComponentVariableMutable } from "src/shared/store/component-mutable/composables/useComponentVariableMutable";
import { useComponentVariableImmediateParentComponentId } from "src/shared/store/component-graph-v2/composables/useComponentVariableImmediateParentCompnentId";
import { hasChildComponentVariables, hasParentComponentVariable, } from "src/shared/store/component-graph-v2";
import { useComponentVariableNodeType } from "src/shared/store/component-graph-v2/composables/useComponentVariableNodeType";
import ChildVariableManagementDrawer from "../../child-variable-management-drawer/ChildVariableManagementDrawer.vue";
import { isComponentVariableMutable } from "src/shared/store/component-mutable/model/ComponentVariableMutable";
import { useBuiltComponentSetting } from "src/shared/store/component-built/composables/useBuiltComponentSetting";
import { isBuiltCampaignComponentVariable } from "src/shared/store/component-built/setting/model/BuiltCampaignComponentVariable";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableKebabMenu',
    props: {
        componentMutableKey: {},
        componentId: {},
        variableName: {}
    },
    emits: ["toggleWorkingValueEvaluatableness"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const isDropdownVisible = ref(false);
        const onVisibleChange = (visible) => {
            isDropdownVisible.value = visible;
        };
        const emit = __emit;
        const { componentVariableMutable } = useComponentVariableMutable(toRef(props, "componentMutableKey"), toRef(props, "variableName"));
        const { componentVariable } = useComponentVariable(toRef(props, "componentId"), toRef(props, "variableName"));
        const { builtComponentSetting } = useBuiltComponentSetting(toRef(props, "componentId"), toRef(props, "variableName"));
        const { componentVariableNodeType } = useComponentVariableNodeType(toRef(props, "componentId"), toRef(props, "variableName"));
        const { componentVariableImmediateParentComponentId } = useComponentVariableImmediateParentComponentId(toRef(props, "componentId"), toRef(props, "variableName"));
        const parentComponentDisplayName = computed(() => {
            if (!componentVariableImmediateParentComponentId.value) {
                return undefined;
            }
            return useComponentDisplayName(componentVariableImmediateParentComponentId.value).displayName.value;
        });
        const isSourceComponentIdDifferent = computed(() => {
            return (builtComponentSetting.value &&
                isBuiltCampaignComponentVariable(builtComponentSetting.value) &&
                builtComponentSetting.value.source_component_id !== props.componentId);
        });
        const campaignEditorPathForParent = useCampaignEditorPath(componentVariableImmediateParentComponentId);
        const showViewImpactDropdownItem = computed(() => {
            return (componentVariableNodeType.value &&
                hasChildComponentVariables(componentVariableNodeType.value));
        });
        const showPushToParentDropdownItem = computed(() => {
            var _a;
            return (componentVariableNodeType.value &&
                hasParentComponentVariable(componentVariableNodeType.value) &&
                builtComponentSetting.value &&
                isBuiltCampaignComponentVariable(builtComponentSetting.value) &&
                ((_a = builtComponentSetting.value) === null || _a === void 0 ? void 0 : _a.source) === "LOCAL" &&
                parentComponentDisplayName.value !== undefined);
        });
        const showInheritFromParentDropdownItem = computed(() => {
            var _a;
            return (componentVariableNodeType.value &&
                hasParentComponentVariable(componentVariableNodeType.value) &&
                builtComponentSetting.value &&
                isBuiltCampaignComponentVariable(builtComponentSetting.value) &&
                ((_a = builtComponentSetting.value) === null || _a === void 0 ? void 0 : _a.source) === "LOCAL");
        });
        const showOverrideParentDropdownItem = computed(() => {
            var _a;
            return (componentVariableNodeType.value &&
                hasParentComponentVariable(componentVariableNodeType.value) &&
                builtComponentSetting.value &&
                isBuiltCampaignComponentVariable(builtComponentSetting.value) &&
                ((_a = builtComponentSetting.value) === null || _a === void 0 ? void 0 : _a.source) === "INHERITED");
        });
        const showOpenAssetLocationDropdownItem = computed(() => {
            var _a;
            return (builtComponentSetting.value &&
                isBuiltCampaignComponentVariable(builtComponentSetting.value) &&
                ((_a = builtComponentSetting.value) === null || _a === void 0 ? void 0 : _a.source) === "INHERITED" &&
                isSourceComponentIdDifferent.value &&
                campaignEditorPathForParent.value !== null);
        });
        const showEditDropdownItem = computed(() => {
            return Session.getInstance().isSuperUser() && builtComponentSetting.value;
        });
        const showManageInstancesDropdownItem = computed(() => {
            return (Session.getInstance().isSuperUser() &&
                componentVariableNodeType.value &&
                hasChildComponentVariables(componentVariableNodeType.value));
        });
        const showJsonDropdownItem = computed(() => {
            return Session.getInstance().isSuperUser();
        });
        const showDeleteDropdownItem = computed(() => {
            return Session.getInstance().isSuperUser();
        });
        const areAnyStandardDropdownItemsVisible = computed(() => {
            return (showViewImpactDropdownItem.value ||
                showPushToParentDropdownItem.value ||
                showInheritFromParentDropdownItem.value ||
                showOverrideParentDropdownItem.value ||
                showOpenAssetLocationDropdownItem.value);
        });
        const areAnyAdvancedDropdownItemsVisible = computed(() => {
            return (showEditDropdownItem.value ||
                showManageInstancesDropdownItem.value ||
                showDeleteDropdownItem.value ||
                showJsonDropdownItem.value);
        });
        const useParentComponentVariableValues = () => __awaiter(this, void 0, void 0, function* () {
            if (!componentVariableMutable.value ||
                !isComponentVariableMutable(componentVariableMutable.value)) {
                return;
            }
            componentVariableMutable.value.setSource("INHERITED");
            saveComponentVariable(componentVariableMutable.value);
        });
        const overrideParentComponentVariableValues = () => __awaiter(this, void 0, void 0, function* () {
            if (!componentVariableMutable.value ||
                !isComponentVariableMutable(componentVariableMutable.value)) {
                return;
            }
            componentVariableMutable.value.setSource("LOCAL");
            saveComponentVariable(componentVariableMutable.value);
        });
        return (_ctx, _cache) => {
            return (_unref(builtComponentSetting) &&
                (areAnyStandardDropdownItemsVisible.value ||
                    areAnyAdvancedDropdownItemsVisible.value))
                ? (_openBlock(), _createBlock(_unref(ElDropdown), {
                    key: 0,
                    trigger: "click",
                    "hide-on-click": "",
                    "popper-class": "list list--drop-down list--drop-down--modern",
                    placement: "bottom-end",
                    onVisibleChange: onVisibleChange
                }, {
                    dropdown: _withCtx(() => [
                        _createVNode(_unref(ElDropdownMenu), null, {
                            default: _withCtx(() => [
                                (showViewImpactDropdownItem.value)
                                    ? (_openBlock(), _createBlock(DrawerTrigger, { key: 0 }, {
                                        trigger: _withCtx(({ openDrawer }) => [
                                            _createVNode(_unref(ElDropdownItem), null, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("a", { onClick: openDrawer }, [
                                                        _hoisted_4,
                                                        _createTextVNode(" View Impact")
                                                    ], 8 /* PROPS */, _hoisted_3)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        drawer: _withCtx(({ drawerClosed }) => [
                                            _createVNode(CampaignComponentVariableImpactDrawer, {
                                                "component-id": props.componentId,
                                                "variable-name": props.variableName,
                                                onClosed: drawerClosed
                                            }, null, 8 /* PROPS */, ["component-id", "variable-name", "onClosed"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                (showPushToParentDropdownItem.value)
                                    ? (_openBlock(), _createBlock(DrawerTrigger, { key: 1 }, {
                                        trigger: _withCtx(({ openDrawer }) => [
                                            _createVNode(_unref(ElDropdownItem), null, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("a", { onClick: openDrawer }, [
                                                        _hoisted_6,
                                                        _createTextVNode(" Update \"" + _toDisplayString(parentComponentDisplayName.value) + "\" Default Value ", 1 /* TEXT */)
                                                    ], 8 /* PROPS */, _hoisted_5)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        drawer: _withCtx(({ drawerClosed }) => [
                                            _createVNode(ConfirmPushValueToParentDialog, {
                                                "component-id": props.componentId,
                                                "variable-name": props.variableName,
                                                onClosed: drawerClosed
                                            }, null, 8 /* PROPS */, ["component-id", "variable-name", "onClosed"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                (showInheritFromParentDropdownItem.value)
                                    ? (_openBlock(), _createBlock(_unref(ElDropdownItem), { key: 2 }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("a", { onClick: useParentComponentVariableValues }, [
                                                _hoisted_7,
                                                _createTextVNode(" Use Default Value ")
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                (showOverrideParentDropdownItem.value)
                                    ? (_openBlock(), _createBlock(_unref(ElDropdownItem), { key: 3 }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("a", { onClick: overrideParentComponentVariableValues }, [
                                                _hoisted_8,
                                                _createTextVNode(" Don't Use \"" + _toDisplayString(parentComponentDisplayName.value) + "\" Default Value ", 1 /* TEXT */)
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                (showOpenAssetLocationDropdownItem.value &&
                                    _unref(campaignEditorPathForParent))
                                    ? (_openBlock(), _createBlock(_unref(ElDropdownItem), { key: 4 }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("a", {
                                                target: "_blank",
                                                href: _unref(campaignEditorPathForParent)
                                            }, [
                                                _hoisted_10,
                                                _createTextVNode(" Open Asset Location ")
                                            ], 8 /* PROPS */, _hoisted_9)
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                (areAnyStandardDropdownItemsVisible.value &&
                                    areAnyAdvancedDropdownItemsVisible.value)
                                    ? (_openBlock(), _createBlock(_unref(ElDivider), { key: 5 }))
                                    : _createCommentVNode("v-if", true),
                                (showEditDropdownItem.value)
                                    ? (_openBlock(), _createBlock(DrawerTrigger, { key: 6 }, {
                                        trigger: _withCtx(({ openDrawer }) => [
                                            _createVNode(_unref(ElDropdownItem), null, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("a", { onClick: openDrawer }, [
                                                        _hoisted_12,
                                                        _createTextVNode(" Edit ")
                                                    ], 8 /* PROPS */, _hoisted_11)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        drawer: _withCtx(({ drawerClosed }) => [
                                            _createVNode(EditComponentSettingDrawer, {
                                                "component-id": _ctx.componentId,
                                                "setting-name": _ctx.variableName,
                                                onClosed: drawerClosed
                                            }, null, 8 /* PROPS */, ["component-id", "setting-name", "onClosed"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                (showManageInstancesDropdownItem.value)
                                    ? (_openBlock(), _createBlock(DrawerTrigger, { key: 7 }, {
                                        trigger: _withCtx(({ openDrawer }) => [
                                            _createVNode(_unref(ElDropdownItem), null, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("a", { onClick: openDrawer }, [
                                                        _hoisted_14,
                                                        _createTextVNode(" Manage Instances ")
                                                    ], 8 /* PROPS */, _hoisted_13)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        drawer: _withCtx(({ drawerClosed }) => [
                                            _createVNode(ChildVariableManagementDrawer, {
                                                "component-id": _ctx.componentId,
                                                "variable-name": _ctx.variableName,
                                                onClosed: drawerClosed
                                            }, null, 8 /* PROPS */, ["component-id", "variable-name", "onClosed"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                (showJsonDropdownItem.value && _unref(componentVariable))
                                    ? (_openBlock(), _createBlock(DrawerTrigger, { key: 8 }, {
                                        trigger: _withCtx(({ openDrawer }) => [
                                            _createVNode(_unref(ElDropdownItem), null, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("a", { onClick: openDrawer }, [
                                                        _hoisted_16,
                                                        _createTextVNode("JSON (Raw) ")
                                                    ], 8 /* PROPS */, _hoisted_15)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        drawer: _withCtx(({ drawerClosed }) => [
                                            _createVNode(JsonDrawer, {
                                                data: _unref(componentVariable),
                                                title: _unref(componentVariable).getDisplayName(),
                                                onClosed: drawerClosed,
                                                raw: ""
                                            }, null, 8 /* PROPS */, ["data", "title", "onClosed"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                (showJsonDropdownItem.value && _unref(builtComponentSetting))
                                    ? (_openBlock(), _createBlock(DrawerTrigger, { key: 9 }, {
                                        trigger: _withCtx(({ openDrawer }) => [
                                            _createVNode(_unref(ElDropdownItem), null, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("a", { onClick: openDrawer }, [
                                                        _hoisted_18,
                                                        _createTextVNode("JSON (Built) ")
                                                    ], 8 /* PROPS */, _hoisted_17)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        drawer: _withCtx(({ drawerClosed }) => [
                                            _createVNode(JsonDrawer, {
                                                data: _unref(builtComponentSetting),
                                                title: _unref(builtComponentSetting).getDisplayName(),
                                                level: 1,
                                                onClosed: drawerClosed
                                            }, null, 8 /* PROPS */, ["data", "title", "onClosed"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = ($event) => (isDropdownVisible.value = true)),
                            class: _normalizeClass(["icon-button", {
                                    'icon-button--selected': isDropdownVisible.value,
                                }])
                        }, _hoisted_2, 2 /* CLASS */)
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true);
        };
    }
});
